(function () {
    'use strict';

    angular
        .module('app')
        .service('contactService', contactService);

    contactService.$inject = ['$http'];

    function contactService($http) {
        /* jshint validthis:true */
        var vm = this;
        var baseUrl = '/api/contact';

        function getContactInfo() {
            //alert("service");
            return $http({
                url: baseUrl + '/get-contact',
                method: "GET"
            });
            //return $http.get(baseUrl + '/get-articles');
        }

        vm.getContactInfo = getContactInfo;
    }
})();